import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {GridWrapper, ContentContainer, ContentContainerProps} from "../../../components"

export const StyledGridWrapper = styled(GridWrapper)`
    @media (min-width: ${breakpoints.values.md}px) {
        border-right: none;
    }
`
export const ContentContainerStyled = styled(ContentContainer)<ContentContainerProps>`
    @media (min-width: ${breakpoints.values.md}px) {
        max-width: 25%;
        padding: 1.5rem 0 1rem 1.5rem;
        margin-left: 0;
    }
`
